import React from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch"
import StudentAssessMe from "../../../components/StudentAssessMe/StudentAssessMe";
import Notification from "../../../components/Notification/Notification";

const AssessMe = () => {
  return (
    <>
      {/* Topbar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3"
          >
            AssessMe.Ai
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <Notification />
          </div>
        </div>
      </div>
      <StudentAssessMe />
    </>
  );
};

export default AssessMe;
